<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-configuration-topic-blacklist-legacy">
    <div class="topic-group-section">
      <div class="div-group-viewer-header div-group-name">
        Conversation Topics Blacklist
      </div>
      <div class="div-group-viewer-content">
        <div class="div-group-topics" v-bind:class="{ 'isDisabled': loadingMsg }">
          <div class="div-topic-content" ref="topicContent" v-loading="loading">
            <div v-if="groupTopics && groupTopics.length > 0">
              <div class="div-item" :title="topic.topicDisplayName" v-for="(topic) in groupTopics" :label="topic"
                :key="topic.Name" @click="getMessagesByTopics(topic.mergedTopics, $event)">
                <div class="div-ellipsis-item">{{ topic.topicDisplayName }}</div>
                <i v-if="isRoleAllow(4201)" class="el-icon-error" @click="handleRemoveTopic(topic, $event)"></i>
              </div>
            </div>
            <div v-else class="no-data">
              <div class="no-data-content">
                There are no blacklisted conversation topics. Topics can be blacklisted through the configuration or the
                conversation topics page.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showMessageContent" class="topic-messages-section">
      <div class="div-topic-messages-viewer-header">Conversations</div>
      <div class="div-topic-messages-viewer-content" v-loading="loadingMsg">
        <div ref="conversationMessages" class="div-topic-message-name" v-for="(message, index) in topicMessages"
          v-bind:class="{ selected: (topicMessage && topicMessage.conversationId == message.conversationId) }"
          :key="index" @click="getTranscriptById(message, $event)">
          <div class="message-date">{{ formatMessageHeaderDate(message.date) }}</div>
          <div class="message-right">
            <div class="message-date-time">
              {{ getTimeRange(message) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <wy-analytics-transcript-viewer v-if="(showMessageContent && topicMessages && topicMessages.length > 0) || loadingMsg"
      :parent="module" :messagesTranscripts="messageTranscripts" :selectedMessage="topicMessage" :loading="loadingMsg"
      :fromConfiguration="true" viewName="Conversation Topics Blacklist" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import WyUtils from '../../../library/wy-utils.js';
import WyAnalyticsTranscriptViewer from '../wy-analytics-transcript-viewer.vue';

export default Vue.extend({
  name: 'wy-analytics-configuration-topic-blacklist-legacy',
  title: 'Configuration',
  components: {
    'wy-analytics-transcript-viewer': WyAnalyticsTranscriptViewer
  },
  props: ['controller'],
  
  data() {
    return {
      module: this,
      loading: false,
      loadingMsg: false,
      groupTopics: [],
      topicMessages: [],
      topicMessage: null,
      messageTranscripts: [],

      showMessageContent: false,
      showTranscriptContent: false,
      preMsgObj: null,
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'isRoleAllow']),
  },

  methods: {
    ...mapActions(['fetchContactReasonsBlackListsTopics', 'fetchContactReasonsTopicConversationsWithoutFilters', 'fetchContactReasonsTopicConversationDetail', 'updateContactReasonTopicBlackList']),

    async handleRemoveTopic(topic, event) {
      event.preventDefault();
      event.stopPropagation();

      if (topic.mergedTopics && topic.mergedTopics.length > 0) {
        this.loading = true;
        let res = await this.updateContactReasonTopicBlackList(topic);
        this.loading = false;
        if (!res) {
          this.$root.showNotificationLocale("error", "error.serverErrorTitle", "error.serverErrorMsg");
        }
        else if (res.status == 200) {
          this.$root.showProcessWaitDialogue({ visible: true, processId: res.data.processId });
          setTimeout(async () => {
            let index = this.groupTopics.indexOf(topic);
            if (index > -1) {
              this.groupTopics.splice(index, 1);
            }
            this.removeClassNameFromIcon(event, "selected")
            this.topicMessages = [];
            this.messageTranscripts = [];
            this.topicMessage = null;
            this.showMessageContent = false;
            this.showTranscriptContent = false;
          }, 1000)
        }
        else if (res.status == 409) {
          this.$root.showProcessErrorDialogue({ controller: this, info: res.data });
        }
      }
    },

    async loadBlackList() {
      this.showMessageContent = false;
      this.showTranscriptContent = false;
      this.loading = true;
      this.$refs.topicContent.querySelectorAll(".div-item").forEach(el => {
        if (el.classList.contains("selected")) {
          el.classList.remove("selected");
        }
      })
      let result = await this.fetchContactReasonsBlackListsTopics();
      if (result && result.data && result.data.length > 0) {
        this.groupTopics = result.data;
      }
      this.loading = false;
    },

    handleTimeInNiceFormat(Millis) {
      let seconds = Millis / 1000;

      return WyUtils.toNiceTimeFormat(seconds);
    },

    async getMessagesByTopics(topics, event) {
      if (event) {
        if (event.target.classList.contains("div-ellipsis-item")) {
          this.removeClassNameFromIcon(event, "selected");
          event.target.parentNode.classList.add("selected");
        }
        else {
          this.removeClassName(event, "selected");
          event.target.classList.add("selected");
        }
      }
      // let topics = topic.mergedTopics;
      this.topicMessages = [];
      this.loadingMsg = true;
      this.showMessageContent = true;
      this.showTranscriptContent = false;
      let result = await this.fetchContactReasonsTopicConversationsWithoutFilters({ from: 'blacklist', topics: topics });

      if (result && result.data && result.data.length > 0) {
        await this.getTranscriptById(result.data[0]);

        this.topicMessages = result.data;
        //this.messageTranscripts = this.topicMessages[0].messages;
        //this.topicMessage = this.topicMessages[0];
        // Below is commented out to follow the same convention as other components (line 33 v-bind:class)
        // setTimeout(()=>{
        //   if(document.querySelector(".wy-analytics-configuration-topic-blacklist-legacy .div-topic-message-name")) {
        //     document.querySelector(".wy-analytics-configuration-topic-blacklist-legacy .div-topic-message-name").classList.add("selected");
        //   }
        // }, 100)
        this.showTranscriptContent = true;
      }
      else {
        this.topicMessages = []
        this.messageTranscripts = []
        this.showTranscriptContent = false;
      }

      this.loadingMsg = false;
    },

    async getTranscriptById(item) {
      this.messageTranscripts = [];
      this.showTranscriptContent = false;

      let resultDetail = await this.fetchContactReasonsTopicConversationDetail({ conversationId: item.conversationId })
      if(resultDetail && resultDetail.data) {
        this.topicMessage = resultDetail.data;
        this.messageTranscripts = this.topicMessage.messages;
      }
    },

    formatMessageHeaderDate(date) {
      return WyUtils.formatDateWithDay(date);
    },

    formatMessageDate(date) {
      return WyUtils.formatDate(date);
    },

    getTimeRange(transcript) {
      if(transcript.msgTime) {
        return transcript.msgTime
      }
      else {
        // TODO: This is for V2 API and can be removed later 
        return WyUtils.getTimeRange(transcript);
      }
    },

    toTranscriptLabel(val) {
      return WyUtils.toTranscriptLabel(val);
    },

    addClassName(e) {
      let domEl = null;
      if (e.target.classList.contains("div-topic-message-name")) {
        domEl = e.target;
      }
      if (e.target.parentNode.classList.contains("div-topic-message-name")) {
        domEl = e.target.parentNode;
      }
      if (e.target.parentNode.parentNode.classList.contains("div-topic-message-name")) {
        domEl = e.target.parentNode.parentNode;
      }
      domEl.classList.add("selected");
    },

    removeClassName(e, className) {
      let domEl = null;
      if (e.target.classList.contains("div-topic-message-name")) {
        domEl = e.target;
      }
      if (e.target.parentNode.classList.contains("div-topic-message-name")) {
        domEl = e.target.parentNode;
      }
      if (e.target.parentNode.parentNode.classList.contains("div-topic-message-name")) {
        domEl = e.target.parentNode.parentNode;
      }
      if (domEl && domEl.classList.length > 0) {
        let removeClassName = domEl.classList[0];
        document.querySelectorAll(".wy-analytics-configuration-topic-blacklist-legacy ." + removeClassName).forEach(el => {
          if ((' ' + el.className + ' ').indexOf(' ' + className + ' ') > -1) {
            el.classList.remove(className);
          }
        })
      }
      else {
        let removeClassName = e.target.classList[0];
        document.querySelectorAll(".wy-analytics-configuration-topic-blacklist-legacy ." + removeClassName).forEach(el => {
          if ((' ' + el.className + ' ').indexOf(' ' + className + ' ') > -1) {
            el.classList.remove(className);
          }
        })
      }
    },

    removeClassNameFromIcon(e, className) {
      if (e.target.parentNode.classList.length > 0) {
        let removeClassName = e.target.parentNode.classList[0];
        document.querySelectorAll(".wy-analytics-configuration-topic-blacklist-legacy ." + removeClassName).forEach(el => {
          if ((' ' + el.className + ' ').indexOf(' ' + className + ' ') > -1) {
            el.classList.remove(className);
          }
        })
      }
    },
  },

  mounted() {
    this.loadBlackList();
  }
});
</script>

<style lang="scss">
.contact-reason-group-topics-tab-info-pop-over {
  border-color: var(--site-font-chart-color) !important;
  color: #E4E8EC;
  line-height: 18px;

  .popper__arrow:after,
  .popper__arrow:before {
    display: block !important;
    border-bottom-color: #000 !important;
  }

  .popper-item {
    margin-bottom: 15px;
  }

}

.wy-analytics-configuration-topic-blacklist-legacy {
  display: inline-flex;
  //margin: 5px 0px 0px 25px;
  width: 100%;
  // height: calc(98vh - 258px);
  height: 100%;
  min-width: 1093px;

  .transcripts-viewer-header-right {
    overflow-y: auto;
    height: 204px !important;
    padding-right: 20px;

    &::-webkit-scrollbar {
      background-color: #000 !important;
      width: 8px !important;
    }

    &::-webkit-scrollbar-thumb {
      background: #C8C8C8 !important;
      border-radius: 5px;
    }
  }

  .contact-reason-transcript-tab-info-pop-over {
    padding: 12px 7px 10px 15px !important;
  }

  .popper__arrow:after,
  .popper__arrow:before {
    display: block !important;
    border-bottom-color: #000 !important;
  }

  .flex-container {
    // display: flex;
    // justify-content: space-around;
  }

  .sentiment-icon-positive {
    cursor: pointer;
    background-image: url('../../../assets/icons/icon_positive_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 61px;
    bottom: 8px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-neutral {
    cursor: pointer;
    background-image: url('../../../assets/icons/icon_neutral_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    bottom: 8px;
    right: 61px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-negative {
    cursor: pointer;
    background-image: url('../../../assets/icons/icon_negative_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 61px;
    border-radius: 100px;
    border: 0px;
    bottom: 8px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .isDisabled {
    pointer-events: none;
    opacity: 0.4;
  }

  .topic-group-section {
    //margin: 20px 0px 20px 0px;
    min-width: 311px;
    margin-right: 15px;
    width: 25%;
    padding: 20px 0px 15px 0px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 15px;
    opacity: 1;

    .div-group-viewer-content {
      margin-top: 10px;
      border-top: 1px solid #E8E8E8;
      height: -webkit-fill-available;
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 12px;
      height: calc(100% - 28px);
    }

    .div-group-viewer-header.div-group-name {
      font-size: 16px;
      font-weight: 500;
      padding: 0px 10px 4px 30px;
    }

    .div-group-topics {
      margin-bottom: 8px;

      .div-topic-content {
        height: fit-content;
        // padding-top: 10px;

        .div-item {
          color: var(--site-font-primary-color);
          font-weight: normal;
          margin: 0px 0px 0px 0px;
          line-height: 19px;
          padding: 12px 10px 5px 30px;
          font-size: 12px;
          cursor: pointer;

          .div-ellipsis-item {
            width: 88%;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .div-item:hover {
          background: #f5f7fa;
        }

        .div-item.selected {
          background: #E2ECF7;
        }

        .el-icon-error {
          float: right;
          // display: none;
          top: 2px;
          left: -10px;
          position: relative;
          color: #80A6CD;
          cursor: pointer;
          font-size: 15px;
        }

        .el-icon-error.is-disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }

        .div-item:hover .el-icon-error {
          display: block;
        }
      }
    }
  }

  .topic-messages-section {
    //margin: 20px 0px 20px 15px;
    min-width: 300px;
    width: 335px;
    padding: 16px 0px 10px 0px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 15px 0px 0px 15px;
    opacity: 1;

    .div-topic-messages-viewer-header {
      font-size: 16px;
      font-weight: 500;
      padding: 4px 10px 9px 30px;
    }

    .div-topic-messages-viewer-content {
      margin-top: 5px;
      border-top: 1px solid #E8E8E8;
      height: calc(100% - 28px);
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 20px;
      // padding-top: 10px;

      .div-topic-message-name {
        font-size: 12px;
        word-break: keep-all;
        cursor: pointer;
        color: var(--site-font-primary-color);
        font-weight: normal;
        margin: 0px 0px 0px 0px;
        line-height: 20px;
        padding: 12px 10px 10px 30px;

        .message-date {
          width: 110px;
          display: inline-block;
        }

        .message-right {
          float: right;
          width: 130px;

          .message-date-time {
            text-align: left;
            padding-right: 10px;
          }
        }
      }

      .div-topic-message-name:hover {
        background: #f5f7fa;
      }

      .div-topic-message-name.selected {
        background: #E2ECF7;
      }
    }
  }



  .el-message {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: #FFF;
    position: fixed;
    left: 50%;
    top: 90px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color: #395167;
    -webkit-transition: opacity .3s, top .4s, -webkit-transform .4s;
    transition: opacity .3s, top .4s, -webkit-transform .4s;
    transition: opacity .3s, transform .4s, top .4s;
    transition: opacity .3s, transform .4s, top .4s, -webkit-transform .4s;
    padding: 15px 15px 15px 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    // background: #FCFCFC 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #214586;
    border-radius: 15px;
    width: fit-content !important;
    min-width: unset;
  }

  .el-message .el-icon-warning {
    color: var(--site-font-primary-color) !important;
  }

  .el-message__icon {
    margin-right: 10px;
  }

  .el-icon-warning:before {
    content: "\E7A3";
  }

  .el-message--warning .el-message__content {
    color: #FFF !important;
    padding-right: 30px;
  }

  .undo-merge-success-message .el-message__content {
    padding-right: 0px;
  }

  .el-loading-mask {
    bottom: 12px;

    .el-loading-spinner {
      top: 35%;
      background: var(--site-loading-icon);
      background-repeat: no-repeat;
      background-size: 25px;
      background-position: center;

      .circular {
        display: inline-block;
        width: 90px;
        height: 90px;
      }
    }

    .el-loading-spinner .path {
      -webkit-animation: loading-dash 2s ease-in-out infinite;
      animation: loading-dash 2s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2.5 !important;
      stroke: #0C2837 !important;
      stroke-linecap: round;

    }
  }

  .el-message.undo-merge-message p {
    padding-right: 30px !important;
  }

  .el-message p {
    padding-right: 4px !important;
  }

  .el-message__content {
    padding: 0;
    font-size: 14px;
    line-height: 1;
  }

  .no-data {
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .no-data-icon {
      display: block;
      border: none;
      height: 155px;
      width: 155px;
      background-position-x: 50%;
      background-repeat: no-repeat;
      background-image: url(../../../assets/icons/icon_no_data_new.svg);
      margin-bottom: 10px;
    }

    .no-data-title {
      font-size: 20px !important;
      color: var(--site-font-tertiary-color) !important;
      font-weight: 600;
      margin-bottom: 12px;
    }

    .no-data-content {
      font-size: 14.22px;
      color: var(--site-font-tertiary-color) !important;
      line-height: 18px;
      font-weight: 400;
      text-align: left;
    }
  }

  .message-transcripts-section {
    padding: 15px 0px 30px 0px;

    .div-message-transcripts-viewer-content {
      // height: 98%;
      height: calc(100vh - 296px);
    }
  }

}
</style>